<template>
  <div></div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  PATH: "controladores/controller.php",
  FECHA_ACTUAL: moment().format("YYYY-MM-DD 00:00:00"),
  PERMISO: "",
  _rules: {
    //required: value => !!value || "Campo Obligatorio.",
    pass: (v) => (!v && v.length >= 8) || "Mínimo 8 digitos",
    //email: v => /.+@.+/.test(v) || "Debe ingresar un E-mail valido",
    //caracteristica: v => (v && v.length >= 4) || "Mínimo 6 numeros",
    //cel: v => (v && v.length >= 6) || "Mínimo 6 numeros"
  },

  /*---------------- funcion de consulta -------------------- */
  enviar: function (tipoMetodo, metodo, parametros) {
    var servidorUrl = process.env.VUE_APP_API + this.PATH;
    var resultado;

    let local = window.localStorage.getItem("EPA_AUTH");

    if (local != null) {
      let localJson = JSON.parse(local);
      var token = localJson.token;

      /*var header = {
        Authorization: "Bearer " + token,
        "Content-Type": "application/x-www-form-urlencoded"
      };*/

      if (parametros != "" && parametros != undefined) {
        parametros += "&token=" + token;
      } else {
        parametros += "token=" + token;
      }
    }

    switch (tipoMetodo) {
      case "get":
        resultado = axios
          .get(servidorUrl + "?funcion=" + metodo + "&" + parametros, {
            //headers: header
          })
          .then((result) => {
            //console.log("ok: ", result);
            return result;
          })
          .catch((error) => {
            console.log("error.response.status: ", error.response.status);
            console.log("error.response.status: ", error.response.data);
            document.location.href = "/mensaje";
            //return "{status: '"+error.response.status+"', msj: '"+error.response.data+"'}";
          })
          .finally(() => {
            //console.log("Final")
          });

        break;

      case "post":
        resultado = axios
          .post(servidorUrl, {
            funcion: metodo,
          })
          .then((result) => {
            //console.log("ok: " + metodo + " |  Parametros: -> " + parametros);
            return result;
          })
          .catch(() => {
            /*console.log(
              "catch: " + metodo + " |  Parametros: -> " + parametros
            );*/
          })
          .finally(() => {
            //console.log("Final")
          });
        break;

      default:
        break;
    }

    return resultado;
  },
  /*------------------------------------------------------------------------- */
  /*------- funcion para poner primera letra de c/palabra en mayuscula -------*/
  ucFirst: function (vstring) {
    let stringArray = vstring.split(" ");
    let stringAux = "";

    for (var i = 0; i < stringArray.length; i++) {
      stringAux += stringArray[i].charAt(0).toUpperCase();
      stringAux += stringArray[i].slice(1);
      stringAux += " ";
    }
    stringAux = stringAux.trim();

    return stringAux;
  },
  /*------------------------------------------------------------------------- */
  /*------- funcion para que verifica si la fecha actual esta dentro de un rango -------*/
  enRangoDeFechas: function (fecha_inicio, fecha_fin) {
    let enRango = false;

    if (this.FECHA_ACTUAL >= fecha_inicio && this.FECHA_ACTUAL <= fecha_fin)
      enRango = true;
    /*console.log(
      "enRangoDeFechas: ",
      fecha_inicio,
      fecha_fin,
      this.FECHA_ACTUAL,
      enRango
    );*/
    return enRango;
  },
  /*------------------------------------------------------------------------- */
  /*------- funcion para limitar ingreso de caracteres en input (solo numeros) -------*/
  soloNumeros(e) {
    var key = window.event ? e.which : e.keyCode;
    if (key < 48 || key > 57) {
      e.preventDefault();
    }
  },
  /*------------------------------------------------------------------------- */
  /*------- funcion para limitar ingreso de caracteres en input (solo decimales) -------*/
  soloDecimales(e) {
    var key = window.event ? e.which : e.keyCode;

    // var RE = /^\d*\.?\d*$/;
    // if (RE.test(e))

    if ((key < 48 || key > 57) && key != 46) {
      e.preventDefault();
    } else {
      if (key == 46) {
        if (this.montoCompra.includes(".")) e.preventDefault();

        var value = this.montoCompra.concat(e.key);
        if (value.indexOf(".") < 1) {
          e.preventDefault();
        }
      }
    }
  },
  /*------------------------------------------------------------------------- */
};
</script>

<style scoped>
</style>